// Copy paste from example in documentation
// See https://jqueryui.com/autocomplete/#categories
$.widget('custom.autocompleteContractCustomer', $.ui.autocomplete, {
    _create() {
        this._super();
    },
    _renderMenu(ul, items) {
        ul.addClass('M-customerAutocomplete__menu');
        $.each(items, (index, item) => {
            const li = this._renderItemData(ul, item);
            li.attr('aria-label', `${item.label}`);
        });
    },
    _renderItem(ul, item) {
        return $('<li class="M-searchAutocomplete__menuItem">').html(item.labelHtml).appendTo(ul);
    },
});

Bingo.Contract = {};
Bingo.Contract.CustomerAutocomplete = class {
    constructor($wrapper, options) {
        const defaults = {
            btnClearSelector: '.js-textField__searchReset',
            filledClass: '-filled',
            inputName: 'owner',
            customerInputSelector: '[name="owner_id"]',
        };

        this.options = $.extend(defaults, options);
        this.wrapper = $wrapper;
        this.btnClear = $wrapper.find(this.options.btnClearSelector);
        this.searchUrl = this.wrapper.attr('data-customer-autocomplete-search-url');
        this.customerInput = $wrapper.find(this.options.customerInputSelector);
        this.input = $wrapper.find(`[name='${this.options.inputName}']`);

        this.btnClear.on('click', (e) => {
            e.stopImmediatePropagation();
            this.clearAutocomplete();
        });

        this.input.autocompleteContractCustomer({
            minLength: 3,
            delay: 500,
            source: (request, response) => {
                // Load new suggestions
                this.loadSuggestions(request.term).then((data) => {
                    response(data); // Update jquery autocomplete
                });
            },
            select: (event, ui) => {
                const data = ui.item.data;
                this.wrapper.data('selected-item', data);
                this.selectSuggestion(data);
                return false;
            },
            position: {
                my: 'left+0 top+2',
            },
        });
    }

    /**
     * Loads new suggestions from API
     * @param text Search phrase
     * @return Promise
     */
    loadSuggestions(text) {
        ajaxData = {
            value: text,
        };

        return $.nette.ajax({
            type: 'GET',
            url: this.searchUrl,
            data: ajaxData,
        }).then((payload, status, jqXHR) => {
            if (payload.status.code !== 1) {
                Bingo.AjaxFailed.showError(payload.status.message);
                return $.Deferred().reject(jqXHR); // Reject promise
            }

            return payload.data;
        }).then((suggestions) => {
            let data = [];

            // Transform API response to data for autocomplete [{label,  data}]
            for (const i in suggestions) {
                const suggestedData = suggestions[i];
                const suggest = Bingo.Contract.CustomerAutocomplete.getLabel(suggestedData);
                data = data.concat({
                    label: suggest,
                    labelHtml: this.constructor.highlightSearchText(suggest, text),
                    description: suggest,
                    data: suggestedData,
                });
            }
            return data;
        });
    }

    /**
     * @param data
     */
    selectSuggestion(data) {
        if (data.id) {
            this.customerInput.val(data.id);
        }
        this.input.val(Bingo.Contract.CustomerAutocomplete.getLabel(data)).trigger('change');
        this.disable();
    }

    /**
     * Get label from suggested data
     * @param data
     */
    static getLabel(data) {
        let label = `${data.person.firstname} ${data.person.lastname}`;
        if (data.company) {
            label = data.company.companyName.concat(' - ', label);
        }

        return label;
    }

    /**
     * Clear autocomplete
     */
    clearAutocomplete() {
        this.clear();
    }

    /**
     * Disable search input
     */
    disable() {
        this.input.prop('disabled', true);
        this.input.closest('.js-textField').addClass(this.options.filledClass);
    }

    /**
     * Clear search input
     */
    clear() {
        this.input.val('');
        this.input.prop('disabled', false);
        this.input.trigger('change');
        this.input.closest('.js-textField').removeClass(this.options.filledClass);
        this.wrapper.data('selected-item', null);
        this.customerInput.val('');
    }

    /**
     * Returns html string with search text wrapped in <strong>
     * @param suggestion
     * @param searchText
     * @return string
     */
    static highlightSearchText(suggestion, searchText) {
        const searchTextEsc = '('.concat(searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ')');
        return suggestion.replace(new RegExp(searchTextEsc, 'ig'), '<strong>$1</strong>');
    }
};
